import ChangePrimaryWriterContainer from './ChangePrimaryWriterContainer';

export default { ChangePrimaryWriterContainer };
